export enum RiskFindingFilterFormTypes {
    Vendor = 'vendor_id',
    Status = 'status',
}